/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createChainClass } from '../../factoriesAny.js';
export var ChainDependencies = {
  createChainClass: createChainClass
};